import { makeStyles } from "@material-ui/core";

export const LessonCollectableCategoryFormStyles = makeStyles((theme) => ({
  checkbox: {
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(16),
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: "24px",
    },
    "& .MuiButtonBase-root.Mui-checked": {
      color: "black",
    },
  },
  separator: {
    border: "solid 0.8px #e4eaec",
  },
}));
